"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessGameObject = void 0;
var gameObject_1 = require("./gameObject");
/**
 * A gameObject that has the "step" function run every iteration
 */
var ProcessGameObject = /** @class */ (function (_super) {
    __extends(ProcessGameObject, _super);
    function ProcessGameObject(children, onStep) {
        if (children === void 0) { children = {}; }
        var _this = _super.call(this, children) || this;
        _this.onStep = onStep;
        return _this;
    }
    ProcessGameObject.prototype.step = function (delta) {
        var _a;
        (_a = this.onStep) === null || _a === void 0 ? void 0 : _a.call(this, delta);
    };
    return ProcessGameObject;
}(gameObject_1.GameObject));
exports.ProcessGameObject = ProcessGameObject;
